import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-viewer',
  templateUrl: './list-viewer.component.html',
  styleUrls: ['./list-viewer.component.css']
})
export class ListViewerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
